import type { IAnyWidgetParams } from '@core/types'

export type Mapping = Record<string, keyof IAnyWidgetParams>

export const ALIASES: Mapping = {
  jsonld_enabled: 'jsonld',
  live_stream_allow_username_change: 'livestream_allow_username_change', // [CS-7531] BE naming inconsistency
  live_stream_ivs_max_quality_bitrate: 'livestream_ivs_max_quality_bitrate', //
  sku: 'skus', // [CS-9928] - Consistent naming for sku param between AVA and Content
  'widget-config-id': 'widget_config_id', // [CS-15177]
}

/**
 * Apply param aliases. This is useful when we want to rename a param key but
 * the old name could e still in use.
 * @param params
 * @returns
 */
export const aliasWidgetParams = (
  params:
    | IAnyWidgetParams
    | {
        // Aliased keys (e.g. jsonld_enabled) are not on IAnyWidgetParams, and
        // channel config sends booleans and numbers, not only attribute strings.
        [k: string]: string | number | boolean | null
      },
  __mapping_di: Mapping = ALIASES,
): IAnyWidgetParams => {
  return Object.keys(params).reduce((acc, key) => {
    const alias = __mapping_di[key]
    if (alias && !(alias in acc)) {
      acc[alias] = params[key]
      delete acc[key]
    }
    return acc
  }, params)
}
